import React, { useEffect } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { stateIsLoaded } from '@guryou/redux';
import Book from 'modules/book';
import Provider from 'modules/provider';
import VideoCourses from 'modules/videoCourses';
import PublicVideoCourseFiles from 'modules/videoCourses/PublicVideoCourses';
import TopNavigation from 'components/navigation';
import Footer from 'components/Footer';
import NewsLetters from 'components/NewsLetters';
import HomePage from 'modules/homepage';
import Profile from 'modules/profile';
import { SingleVideo } from 'modules/videos';
import getLangugePrefix from 'utils/getLangugePrefix';
import Chat from 'modules/chat';

const languagePrefix = getLangugePrefix();

/**
 * Main layout: TopNavigation (Sidebar) stays outside Switch, only the route area changes.
 */
function FeelMainLayout() {
  const auth = useSelector(state => state.auth);
  const location = useLocation();
  const isLoggedIn = stateIsLoaded(auth) && !!auth?.data;
  const isChatPage = location.pathname === '/chat';
  const isHomePage = location.pathname === '/';
  const isProviderPage = /^\/(en|it)\/provider\/\d+/.test(location.pathname);
  const isVideosPage = location.pathname === '/videos';
  const isVideoCourseDetailsPage = location.pathname.startsWith('/video-courses/');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <TopNavigation />
      <div
        style={
          isLoggedIn
            ? {
                marginLeft: 'var(--sidebar-width, 80px)',
                height: isHomePage ? '100vh' : 'auto',
                maxHeight: isHomePage ? '100vh' : 'none',
                overflow: isHomePage ? 'hidden' : 'visible',
                position: isHomePage ? 'relative' : 'static',
                width: isHomePage ? `calc(100% - var(--sidebar-width, 80px))` : 'auto',
              }
            : {}
        }
      >
        <div
          className={
            isLoggedIn && !isChatPage && !isHomePage
              ? isProviderPage || isVideosPage || isVideoCourseDetailsPage
                ? ''
                : 'p-4 sm:p-6 lg:p-8'
              : isHomePage && isLoggedIn
              ? 'h-full'
              : ''
          }
        >
          <Switch>
            <Route exact path="/read">
              <Redirect to="/" />
            </Route>
            <Route path="/book/" component={Book} />
            <Route path={`${languagePrefix}/provider/:id`} render={props => <Provider {...props} key={props.match.params.id} />} />
            <Route path="/videos/:videoId" component={SingleVideo} />
            <Route exact path="/videos" component={VideoCourses} />
            <Route exact path="/video-courses/:id" component={PublicVideoCourseFiles} />
            <Route exact path="/my-video-courses" render={() => <Redirect to="/videos" />} />
            <Route exact path="/my-video-courses/:id" render={props => <Redirect to={`/video-courses/${props.match.params.id}`} />} />
            <Route path="/profile" component={Profile} />
            <Route exact path="/chat" component={Chat} />
            <Route exact path="/" component={HomePage} />
          </Switch>
        </div>
        {!isLoggedIn && (
          <>
            <NewsLetters />
            <Footer />
          </>
        )}
      </div>
    </>
  );
}

export default FeelMainLayout;
